<template>
  <div class="reports custom">

    <!-- Search -->
    <div class="search">
      <h1>Custom Grouping Report</h1>
      <el-alert v-if="alertTitle !== ''"
        :title="alertTitle"
        :type="alertType"
        :description="callInfo"
        :closable="false"
        show-icon>
      </el-alert>
      <!-- grouping options -->
      <h3>Grouping</h3>
      <transition name="panel">
        <div class="pea-panel">
          <p>Select up to 4 filters, in the order you want to filter reports by.</p>
          <el-select v-model="groupBy" multiple placeholder="Group By" :multiple-limit="4" :class="{groupingError: groupingError}" @change="checkIfFilled" ref="groupingSelect">
            <el-option v-for="(report, index) in reportTypes" :key="index" :label="report.label" :value="report.type"></el-option>
          </el-select>
          <br><br>
        </div>
      </transition>

      <!-- filter options -->
      <h3>Filtering</h3>
      <transition name="panel">
        <div class="pea-panel">
          <advancedSearchFilter :filter.sync="filter" ref="filter" @filterBuilt="getReport" />
          <br>
        </div>
      </transition>
      <br>

      <el-button type="success" @click="prepareReport">Prepare Report</el-button>
    </div>

  </div>
</template>

<script>
import advancedSearchFilter from '@/components/advancedSearch/advancedSearchFilter.vue'
import Filter from '@/components/utility/filter.js'
export default {
  name: 'customGroupingReports',
  components: {
    advancedSearchFilter
  },
  data () {
    return {
      loading: false,
      reports: null,
      filter: new Filter(),
      groupBy: [],
      groupingError: false,
      callInfo: '',
      alertType: '',
      alertTitle: '',
      reportTypes: [
        {
          type: 'status',
          label: 'Status'
        },
        {
          type: 'department',
          label: 'Department'
        },
        {
          type: 'cost',
          label: 'Estimate Cost'
        },
        {
          type: 'reason',
          label: 'Reason'
        },
        {
          type: 'approveTime',
          label: 'Time to Approve'
        },
        {
          type: 'projectEndDate',
          label: 'Project End Date'
        },
        {
          type: 'owner',
          label: 'Owner'
        },
        {
          type: 'urgency',
          label: 'Urgency'
        },
        {
          type: 'variance',
          label: 'Spending Variance ($)'
        }
      ],
      reportType: null
    }
  },
  methods: {
    checkIfFilled: function () {
      if (this.groupBy.length) {
        this.groupingError = false
      }
    },
    prepareReport: function () {
      if (this.groupBy.length) {
        this.$refs.filter.buildFilterString()
      } else {
        this.groupingError = true
        window.scrollTo(0, 0)
        this.$notify.error({
          title: 'No Grouping Selected',
          message: 'Please select at least one grouping type.',
          position: 'top-right',
          offset: 60
        })
      }
    },
    getReport: function (filterString) {
      var queryString = 'groupBy=' + this.groupBy.join() + '&filter=' + filterString
      this.$router.push({path: '/report/' + queryString})
    }
  }
}
</script>

<style lang="css" scoped>
h3 {
  margin-top: 20px;
}
</style>

<style>
.groupingError .el-input input {
  border-color: red;
  color: red;
}
</style>
